module.exports = __webpack_public_path__ + "static/media/hall-CSC.6989b810.svg";